import { combineReducers } from 'redux';

import type { SecondaryMarketCpOrderFormData } from './cpOrderForm.model';
import { inputFormReducer } from './input/cpOrderInputForm.reducer';
import { originalFormReducer } from './original/cpOrderOriginalForm.reducer';

export const cpOrderFormDataReducer = combineReducers<SecondaryMarketCpOrderFormData>({
  input: inputFormReducer,
  original: originalFormReducer,
});
